const countryCodeVerify = (countryCode = '', telNumber = '') =>
    countryCode === '86' ? telNumber.length === 11 : telNumber.length >= 7;

export default countryCodeVerify;
